import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/pages/CategoryPage/CategoryPage.js";
const variants = import.meta.webpackContext("/pages/CategoryPage", { recursive: true, regExp: /\.\/__variants__\/plp\-(?:guided\-search\/(?:single|t(?:ext|ile))|visual\-categories\/v2)\/CategoryPage\.js/ });
export default pointCut({ joinPoint, variants });